import BugCatch, { EventPayload } from 'bugcatch-sdk';

const dsn = import.meta.env.VITE_BUGCATCH_DSN;

const isBugCatchEnabled = Boolean(dsn);

if (isBugCatchEnabled) {
    BugCatch.init({
        dsn,
        release: import.meta.env.VITE_APP_VERSION,
        environment: import.meta.env.MODE,
        debug: import.meta.env.DEV,
        ignoreErrors: [/ResizeObserver loop limit exceeded/, /Network Error/],
        beforeSend(event: EventPayload) {
            event.platform = 'web';
            return event;
        },
    });
}

export const bugCatchEnabled = isBugCatchEnabled;

export default BugCatch;
